/* eslint-disable prettier/prettier */
import { message } from 'ant-design-vue'
import { buyitwith_fix_page_post, buyitwith_fix_delete_id_get, buyitwith_fix_upsert_get } from 'server/modules/13768'
import {
    biw_v2_delete_id_get,
    biw_v2_list_post,
    biw_v2_modify_post,
    biw_v2_page_post,
    biw_v2_query_id_get,
    biw_v2_save_post
} from 'server/modules/13768'

export const buyitwith_fix_page_post_ = async function (params, state) {
    const { success, data, retInfo } = await buyitwith_fix_page_post(params)
    if (success) {
        const { pageNum, pageSize, total, list } = data
        state.pagination = {
            pageNum,
            pageSize,
            total
        }
        state.dataSource = list
    } else {
        message.error(retInfo)
    }
}

export const buyitwith_fix_upsert_get_ = async function (params, state) {
    const { success, data, retInfo } = await buyitwith_fix_upsert_get(params)
    if (success) {
        data && message.success(retInfo)
        state.cancel()
        state.initList()
    } else {
        message.error(retInfo)
    }
}

export const buyitwith_fix_delete_id_get_ = async function (params, state) {
    const { success, retInfo } = await buyitwith_fix_delete_id_get(params)

    if (success) {
        state.initList()
        message.success(retInfo)
    } else {
        message.error(retInfo)
    }
}

export const buyitwith_list_post_ = async function (params, state) {
    const { success, data, retInfo } = await biw_v2_list_post(params)

    if (success) {
        if (data.length) {
            state.coverDataSource = data
            state.changeCoverVisible(true)
            return
        } else {
            state.save()
        }
    } else {
        message.error(retInfo)
    }
} // 编辑

export const buyitwith_modify_post_ = async function (params, state) {
    const { success, retInfo } = await biw_v2_modify_post(params)

    if (success) {
        state.initList()
        state.changeVisible(false)
        message.success(retInfo)
    } else {
        message.error(retInfo)
    }
} // 分页查询

export const buyitwith_page_post_ = async function (params, state) {
    const { success, data, retInfo } = await biw_v2_page_post(params)

    if (success) {
        const { pageNum, pageSize, total, list, pages } = data
        console.log('pages: ', pages)
        console.log('pageNum: ', pageNum)

        state.pagination = {
            pageNum: pageNum > pages ? pages : pageNum === 0 ? 1 : pageNum,
            pageSize,
            total
        }
        state.dataSource = list
    } else {
        message.error(retInfo)
    }
} // 查询单个条目

export const buyitwith_query_id_get_ = async function (params, state) {
    const { success, data, retInfo } = await biw_v2_query_id_get(params)

    if (success) {
        const { month, siteName, terminalName, positions, firstCategoryId, secondCategoryId, thirdCategoryId } = data
        state.postParams = {
            ...state.postParams,
            month,
            siteName,
            terminalName,
            categoryInfos: [[firstCategoryId, secondCategoryId, thirdCategoryId]]
        }
        positions.forEach(v => {
            const array = v.categoryIdInfo.map(i => i.split(',').map(Number)
            )

            state[`categories${v.position}`] = array
        })
        state.siteBarVisible = true
    } else {
        message.error(retInfo)
    }
} // 保存

export const buyitwith_save_post_ = async function (params, state) {
    const { success, retInfo } = await biw_v2_save_post(params)

    if (success) {
        state.initList()
        state.changeVisible(false)
        message.success(retInfo)
    } else {
        message.error(retInfo)
    }
} // 删除

export const buyitwith_delete_id_get_ = async function (params, state) {
    const { success, retInfo } = await biw_v2_delete_id_get(params)

    if (success) {
        state.initList()
        message.success(retInfo)
    } else {
        message.error(retInfo)
    }
}
